<template>
  <div>
    <el-button class="scene-export-btn"
               :class="{'mobile-export-button': mobileButton}"
               round
               icon="mdi mdi-import"
               @click="dialogVisibility = true" />
    <el-dialog :visible.sync="dialogVisibility"
               class="scene-export-dialog"
               append-to-body>
      <span class="modal-text">{{ $t('A complete scene image will be exported at the exact zoom level you applied') }}</span>
      <span class="modal-footer">
        <el-button class="continue-btn"
                   type="primary"
                   @click="handleExportScene">{{ $t('Continue') }}</el-button>
        <el-button class="cancel-btn" @click="dialogVisibility = false">{{ $t('Cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import bus, { EVENTS } from '../report-inspector-scene/bus';

export default {
  name: 'SceneExportButton',
  props: {
    mobileButton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisibility: false
    };
  },
  watch: {
    dialogVisibility(value) {
      if (value) {
        document.getElementsByClassName('v-modal')[0].style.marginTop = 0;
        document.getElementsByClassName('v-modal')[0].style.marginLeft = 0;
      } else {
        document.getElementsByClassName('v-modal')[0].style.marginTop = '104px';
        document.getElementsByClassName('v-modal')[0].style.marginLeft = '80px';
      }
    }
  },
  methods: {
    handleExportScene() {
      bus.$emit(EVENTS.EXPORT_SCENE_IMAGE);
      this.dialogVisibility = false;
    }
  }
};
</script>

<style lang="scss">
.scene-export-btn {
  padding: 2px 12px !important;
  margin-left: 10px;
  background-color: #fff;
  border: 1.5px solid #e2e2e2;

  i {
    font-size: 22px;
    color: $vispera-blue;

    &::before {
      transform: rotate(270deg);
    }

    @include breakpoint(lg-max) {
      font-size: 20px;
    }
  }

  &:hover,
  &:focus {
    background-color: #fff;
  }

  &.mobile-export-button {
    padding: 0 !important;
    margin: 0;
    background-color: transparent;
    border: none;

    i {
      font-size: 22px;
    }
  }
}

.scene-export-dialog {
  .el-dialog {
    width: 100%;
    max-width: 418px;
    margin: 30vh auto !important;
    border-radius: 10px;

    .el-dialog__close {
      font-size: 18px;
      font-weight: 600;
      color: #a3a3a3;
    }

    .el-dialog__body {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 30px 24px !important;
      text-align: center;

      .modal-text {
        margin-bottom: 30px;
        font-weight: 600;
        color: #555;
        word-break: break-word;
      }

      .modal-footer {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;

        .continue-btn,
        .cancel-btn {
          width: 100%;
          max-width: 240px;
          height: 40px;
          margin-left: 0;

          span {
            font-size: 15px;
            font-weight: 600;
            text-transform: uppercase;
          }
        }

        .cancel-btn {
          span {
            color: #555;
          }
        }

        .continue-btn {
          margin-bottom: 5px;
        }
      }
    }
  }
}
</style>
